import { IChartContainer } from "../models/base/chart-container.interface";
import { IComponent } from "./component.interface";

export class HaltedNotificationComponent implements IComponent {
    public id = '';

    public element: HTMLElement;
    private base: IChartContainer;
    
    constructor(element: HTMLElement, base: IChartContainer) {
        this.element = element;
        this.base = base;
        this.subscribeEarningNotification();
    }

    public show() {
        this.element.removeClass('hidden');
    }

    public hide() {
        this.element.addClass('hidden');
    }

    private updateTitle(description: string) {
        this.element.setAttribute('title', description);
    }

    private subscribeEarningNotification() {
        this.base.chartService.subscribeHaltedNotificationData((showNotification: boolean, description: string) => {
            if (showNotification) {
                this.show();
            } else {
                this.hide();
            }
            this.updateTitle(description);
        });
    }
}